import { type EmployeeLevel } from "@prisma/client";

export const generateEmployeeBucketHash = (input: { countryId: number; jobId: number; level: EmployeeLevel }) => {
  return `${input.countryId}-${input.jobId}-${input.level}`;
};
